import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from "./assets/api/http";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Axios from 'axios'
import exequy from './assets/api/exequy' // 导入api接口
import './assets/iconfont/iconfont.css'
import 'animate.css'
import WOW from 'wowjs'
import VDistpicker from 'v-distpicker'
import VueLazyload from 'vue-lazyload'
import MetaInfo from 'vue-meta-info' 
import infiniteScroll from 'vue-infinite-scroll'
import VueAreaLinkage from 'vue-area-linkage';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)
Vue.use(VueAreaLinkage)
Vue.use(infiniteScroll)
Vue.use(MetaInfo)
Vue.prototype.exequy = exequy; // 将api挂载到vue的原型上
Vue.config.productionTip = false
Vue.prototype.http = http;
Vue.use(ElementUI);
Vue.use(WOW);
Vue.prototype.$axios = Axios
Vue.use(VDistpicker);
Vue.use(VueLazyload,{
  preload:1.3,//预加载的宽高
  loading:"img的加载中的显示的图片的路径",
  error:"img加载失败时现实的图片的路径",
  attempt:3,//尝试加载的次数
  listenEvents:['scroll','wheel','mousewheel','resize','animationend','transitionend','touchmove'], //你想让vue监听的事件
})
require('./mock.js')

new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
